import { UnitTransferEventTypeEnumType } from '__generated__/graphql';

export default function unitTransferEventTypeToReadable(
  type: UnitTransferEventTypeEnumType
): string {
  switch (type) {
    case UnitTransferEventTypeEnumType.Created:
      return 'Request Created';
    case UnitTransferEventTypeEnumType.Submitted:
      return 'Submitted';
    case UnitTransferEventTypeEnumType.TransfereeAcknowledged:
      return 'Transferee Acknowledged';
    case UnitTransferEventTypeEnumType.TransfereeDeclined:
      return 'Transferee Declined';
    case UnitTransferEventTypeEnumType.ReviewStarted:
      return 'Review Started';
    case UnitTransferEventTypeEnumType.Rejected:
      return 'Rejected';
    case UnitTransferEventTypeEnumType.JointDematOverridden:
      return 'Joint Demat Warning Overridden';
    case UnitTransferEventTypeEnumType.ValuationReportRequested:
      return 'Valuation Report Requested';
    case UnitTransferEventTypeEnumType.EscrowExceptionRequested:
      return 'Escrow Exception Requested';
    case UnitTransferEventTypeEnumType.EscrowExceptionOpsApproved:
      return 'Escrow Exception Approved by Ops';
    case UnitTransferEventTypeEnumType.EscrowExceptionApproved:
      return 'Escrow Exception Fully Approved';
    case UnitTransferEventTypeEnumType.EscrowExceptionDeclined:
      return 'Escrow Exception Declined';
    case UnitTransferEventTypeEnumType.ConditionsIssued:
      return 'Conditions Issued';
    case UnitTransferEventTypeEnumType.DocumentUploaded:
      return 'Document Uploaded';
    case UnitTransferEventTypeEnumType.DocumentsSubmittedForReview:
      return 'Documents Submitted For Review';
    case UnitTransferEventTypeEnumType.DocumentsMarkedIncomplete:
      return 'Documents Marked Incomplete';
    case UnitTransferEventTypeEnumType.DocumentsVerified:
      return 'Documents Verified';
    case UnitTransferEventTypeEnumType.SigningInitiated:
      return 'Signing Initiated';
    case UnitTransferEventTypeEnumType.SignatureSent:
      return 'Signature Request Sent';
    case UnitTransferEventTypeEnumType.SignatureCompleted:
      return 'Signature Completed';
    case UnitTransferEventTypeEnumType.SignatureDeclined:
      return 'Signature Declined';
    case UnitTransferEventTypeEnumType.ExecutionCompleted:
      return 'Execution Completed';
    case UnitTransferEventTypeEnumType.EffectiveDateSet:
      return 'Effective Date Set';
    case UnitTransferEventTypeEnumType.DisUnlocked:
      return 'DIS Unlocked';
    case UnitTransferEventTypeEnumType.Withdrawn:
      return 'Withdrawn';
    case UnitTransferEventTypeEnumType.NoteAdded:
      return 'Note Added';
    default:
      return type;
  }
}
